let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f7gBj")).then(() => parcelRequire('3JPR8'));